import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { thunks } from '@redux/app';
import { SplashScreen } from '@components';
import { bindActionCreators } from 'redux';

class Logout extends Component {
	UNSAFE_componentWillMount() {
		const {
			logout,
		} = this.props;

		logout();
	}

	shouldComponentUpdate = () => (false)

	render() {
		return <SplashScreen />;
	}
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
	logout : bindActionCreators(thunks, dispatch).logout,
});

Logout.propTypes = {
	logout : PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
